module.exports = __webpack_public_path__ + "img/spin_btn.d3315bb4.png";